import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
import TileLayer from "ol/layer/Tile";
import XYZ from "ol/source/XYZ";
import { inject, watch, onMounted, onUnmounted, computed } from "vue";
const __default__ = {
  name: "EvgSourceXYZ"
};
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    attributions: {},
    attributionsCollapsible: {
      type: Boolean
    },
    cacheSize: {
      default: 2048
    },
    crossOrigin: {},
    imageSmoothing: {
      type: Boolean
    },
    opaque: {
      type: Boolean
    },
    projection: {
      default: "EPSG:3857"
    },
    reprojectionErrorThreshold: {
      default: 0.5
    },
    maxZoom: {
      default: 28
    },
    minZoom: {
      default: 0
    },
    maxResolution: {},
    tileGrid: {},
    tileLoadFunction: {},
    tilePixelRatio: {
      default: 1
    },
    tileSize: {
      default: () => [256, 256]
    },
    tileUrlFunction: {},
    url: {},
    urls: {},
    wrapX: {
      type: Boolean
    },
    transition: {},
    zDirection: {}
  },
  setup(__props) {
    const props = __props;
    const layer = inject("tileLayer", () => computed(() => new TileLayer()), true);
    const source = computed(() => new XYZ(props));
    watch(source, () => {
      layer.value.setSource(source.value);
    });
    watch(layer, () => {
      layer.value.setSource(source.value);
    });
    onMounted(() => {
      layer.value.setSource(source.value);
    });
    // Note: setSource actually allows null, but seems incorrectly declared
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    onUnmounted(() => layer?.value?.setSource(null));
    return (_ctx, _cache) => {
      return false ? (_openBlock(), _createElementBlock("div", _hoisted_1)) : _createCommentVNode("", true);
    };
  }
});